function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import Bar from './bar';
import FullScreen from './fullscreen';
import Danmaku from './danmaku';
import AdvancedDanmaku from './advancedDanmaku';
import handleOption from './options';
import Timer from './timer';
import Controller from './controller';
import HotKey from './hotKey';
import HighEnergy from './highEnergy';
import Events from './events';
import VideoColor from './videoColor';
import PlayerInfo from './playerInfo';
import ContextMenu from './contextmenu';
import InfoPanel from './info-panel';
import Template from './template';
import utils from './utils';
import DanmakuAuxiliary from './danmakuAuxiliary';
import tplResolution from '../../template/resolution.art';
import tplVideo from '../../template/video.art';
import { Switch } from './components/components';
var index = 0;
var instances = [];
var mfunsPlayer = function () {
    function mfunsPlayer(options) {
        var _this$options$current, _this$options, _this$options$danmaku, _this = this;
        _classCallCheck(this, mfunsPlayer);
        this.options = handleOption(options);
        this.template = new Template(this.options, this);
        this.events = new Events();
        this.utils = utils;
        this.container = options.container;
        this.container.classList.add('mfunsPlayer');
        this.autoSwitch = this.options.autoSwitch;
        this.autoSkip = this.options.autoSkip;
        this.autoPlay = this.options.autoPlay;
        this.widescreen = this.options.widescreen;
        this.unableTimeupdate = false;
        this.isPlayEnd = false;
        this.isSwitched = false;
        this.isShowMenu = false;
        this.plugins = {};
        this.components = {};
        this.playTimer = null;
        this.loadTimer = null;
        this.video = this.template.video;
        this.currentVideo = (_this$options$current = this.options.currentVideo) !== null && _this$options$current !== void 0 ? _this$options$current : 0;
        this.danmakuAuxiliary = null;
        this.arrow = this.container.offsetWidth <= 500;
        this.videoColor = new VideoColor(this);
        this.playerInfo = new PlayerInfo(this);
        this.bar = new Bar(this.template);
        this.controller = new Controller(this);
        this.timer = new Timer(this);
        this.fullScreen = new FullScreen(this);
        this.contextMenu = new ContextMenu(this);
        this.hotkey = new HotKey(this);
        this.infoPanel = new InfoPanel(this);
        this.initVideo(this.video, this.options.video[this.currentVideo].type);
        this.initPlayerTip();
        this.mute(this.options.muted);
        this.volume(this.options.volume, true);
        if ((_this$options = this.options) !== null && _this$options !== void 0 && (_this$options$danmaku = _this$options.danmaku) !== null && _this$options$danmaku !== void 0 && _this$options$danmaku.api || this.options.video[this.currentVideo].danmakuAddition) {
            var _this$options$danmaku2, _this$options$danmaku3, _this$options$danmaku4, _this$options$danmaku5, _this$options$danmaku6, _this$options$video$t;
            this.showDanmaku = this.options.danmaku.showDanmaku;
            this.danmakuOptions = {
                container: this.template.danmaku,
                opacity: (_this$options$danmaku2 = this.options.danmaku.opacity) !== null && _this$options$danmaku2 !== void 0 ? _this$options$danmaku2 : 1,
                fontScale: (_this$options$danmaku3 = this.options.danmaku.fontScale) !== null && _this$options$danmaku3 !== void 0 ? _this$options$danmaku3 : 1,
                speed: (_this$options$danmaku4 = this.options.danmaku.speed) !== null && _this$options$danmaku4 !== void 0 ? _this$options$danmaku4 : 1,
                limitArea: (_this$options$danmaku5 = this.options.danmaku.limitArea) !== null && _this$options$danmaku5 !== void 0 ? _this$options$danmaku5 : 4,
                callback: function callback(length, advDanData, isReload) {
                    _this.danLength = length;
                    _this.template.danmakuCount.innerHTML = '共 '.concat(length, ' 条弹幕');
                    _this.danmakuLoaded = true;
                    _this.template.danmakuLoad.innerHTML = '请求弹幕数据中... [完成]';
                    _this.loadHighEnergy();
                    _this.videoLoaded && _this.template.footBar.classList.remove('loading');
                },
                error: function error(msg, isReload) {
                    _this.template.danmakuLoad.innerHTML = '请求弹幕数据中... [失败]';
                    _this.template.danmakuCount.innerHTML = '共 0 条弹幕';
                    _this.loadHighEnergy();
                    _this.template.loading.classList.remove('show');
                },
                apiBackend: this.options.apiBackend,
                borderColor: '#FFFFFF',
                height: 29,
                time: function time() {
                    return _this.video.currentTime;
                },
                videoIndex: function videoIndex() {
                    return _this.currentVideo;
                },
                isShow: this.showDanmaku,
                danmakuCatch: (_this$options$danmaku6 = this.options.danmaku.danmakuCatch) !== null && _this$options$danmaku6 !== void 0 ? _this$options$danmaku6 : false,
                unlimited: false,
                api: {
                    address: this.options.danmaku.api,
                    id: this.options.video[this.options.currentVideo].danId,
                    danmakuAddition: this.options.video[this.options.currentVideo].danmakuAddition,
                    token: this.options.danmaku.token,
                    otherDanParams: (_this$options$video$t = this.options.video[this.options.currentVideo].otherDanParams) !== null && _this$options$video$t !== void 0 ? _this$options$video$t : ''
                },
                events: this.events
            };
            if (this.options.advancedDanmaku) {
                this.danmakuOptions.api.advDanApi = {
                    id: this.options.video[this.options.currentVideo].advDanId,
                    address: this.options.advancedDanmaku.api,
                    token: this.options.advancedDanmaku.token
                };
            }
            this.danmaku = new Danmaku(this.danmakuOptions, this);
            this.advancedDanmaku = new AdvancedDanmaku(this, []);
            this.controller.initDanmakuSettingsButton();
        } else {
            this.template.footBar && this.template.footBar.classList.add('hide');
        }
        if (this.options.video[this.currentVideo].resolution) {
            this.resolution = this.options.video[this.currentVideo].resolution.find(function (el) {
                return el.isDefault;
            });
            this.template.resolutionInfo.innerHTML = this.resolution.name + ' ' + this.resolution.label;
        }
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.container.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        this.rescale = this.rescale.bind(this);
        index++;
        instances.push(this);
        this.showMask();
    }
    _createClass(mfunsPlayer, [
        {
            key: 'showMask',
            value: function showMask() {
                this.template.videoWrap.classList.add('load');
                if (this.options.danmaku) {
                    this.template.danmakuLoad.classList.remove('hide');
                    this.template.danmakuLoad.innerHTML = '请求弹幕数据中...';
                }
                this.template.videoLoad.classList.remove('hide');
                this.template.videoLoad.innerHTML = '请求视频数据中...';
                this.template.mask.classList.add('mfunsPlayer-mask-show');
                if (this.options.video[this.currentVideo].pic) {
                    this.template.mask.style.background = 'url("'.concat(this.options.video[this.currentVideo].pic, '")');
                    this.template.mask.style.backgroundSize = '100% 100%';
                }
            }
        },
        {
            key: 'removeMask',
            value: function removeMask() {
                var _this2 = this;
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'loaded';
                if (this.videoLoaded || !this.danmaku || type === 'error') {
                    this.template.danmakuRoot && this.template.danmakuRoot.classList.remove('loading');
                    this.template.footBar && this.template.footBar.classList.remove('loading');
                    this.checkAutoPlay();
                    setTimeout(function () {
                        type === 'error' && _this2.template.loading.classList.remove('show');
                        _this2.template.videoWrap.classList.remove('load');
                        _this2.template.danmakuLoad.classList.add('hide');
                        _this2.template.videoLoad.classList.add('hide');
                        _this2.template.playerLoad.classList.add('hide');
                        _this2.template.mask.style.background = '';
                        _this2.template.mask.classList.remove('mfunsPlayer-mask-show');
                    }, 500);
                }
            }
        },
        {
            key: 'loadHighEnergy',
            value: function loadHighEnergy() {
                var _this3 = this;
                if (this.videoLoaded) {
                    if (!this.highEnergy && window.echarts) {
                        this.highEnergy = new HighEnergy(this);
                        this.highEnergy.resize();
                        this.danmakuHighEnergySwitch = new Switch({
                            el: this.template.danmaku_highEnergy_switch,
                            value: this.options.danmaku.showHighEnergy,
                            onChange: function onChange(value) {
                                if (value) {
                                    var _this3$highEnergy;
                                    (_this3$highEnergy = _this3.highEnergy) === null || _this3$highEnergy === void 0 ? void 0 : _this3$highEnergy.show();
                                } else {
                                    var _this3$highEnergy2;
                                    (_this3$highEnergy2 = _this3.highEnergy) === null || _this3$highEnergy2 === void 0 ? void 0 : _this3$highEnergy2.hide();
                                }
                            }
                        });
                    } else {
                        var _this$highEnergy;
                        (_this$highEnergy = this.highEnergy) === null || _this$highEnergy === void 0 ? void 0 : _this$highEnergy.reload();
                    }
                }
            }
        },
        {
            key: 'seek',
            value: function seek(time, autoSkip) {
                this.canplay = false;
                time = Math.max(time, 0);
                if (this.video.duration) {
                    time = Math.min(time, this.video.duration);
                }
                this.bar.set('played', time / this.video.duration, 'width');
                this.highEnergy && this.highEnergy.update(time / this.video.duration);
                this.template.currentTime.innerText = utils.secondToTime(time);
                this.updateVideoPosition(this.video.currentTime);
                this.video.currentTime = time;
            }
        },
        {
            key: 'skip',
            value: function skip(text, time, autoSkip) {
                var _this4 = this;
                this.template.skipText.innerText = text;
                this.template.skipLink.innerText = utils.secondToTime(time);
                autoSkip && this.seek(time, autoSkip);
                this.template.skipLink.classList[autoSkip ? 'add' : 'remove']('autoSkip');
                this.skipTime && clearTimeout(this.noticeTime);
                this.template.skip.classList.add('show');
                setTimeout(function () {
                    autoSkip && _this4.hideTip('skip');
                }, 4000);
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.video.pause();
                this.timer.disable('loading');
                if (this.controller.noActivity || !this.options.activity.length)
                    return;
                this.controller.switchActivity();
                this.template.activityMask.classList.add('show');
            }
        },
        {
            key: 'play',
            value: function play() {
                var _this5 = this;
                var forcePlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this.timer.enable('loading');
                if (!this.canplay) {
                    this.timer.enable('loading');
                }
                this.video.play().then(function () {
                    _this5.template.activityMask.classList.remove('show');
                })['catch'](function (e) {
                    _this5.notice('视频播放异常\uFF0C如果无法正常播放\uFF0C请', true, {
                        callback: function callback() {
                            _this5.reload();
                        },
                        text: '重新加载'
                    });
                });
                if (this.options.mutex) {
                    for (var i = 0; i < instances.length; i++) {
                        if (this !== instances[i]) {
                            instances[i].pause();
                        }
                    }
                }
            }
        },
        {
            key: 'checkAutoPlay',
            value: function checkAutoPlay() {
                var _this6 = this;
                if (this.autoPlay || this.isReloaded || this.isSwitched) {
                    if (this.autoPlay && !this.isSwitched) {
                        this.mute();
                        this.play();
                        this.notice('已静音自动播放', true, {
                            callback: function callback() {
                                _this6.mute(false);
                                _this6.volume(_this6.options.volume, true);
                            },
                            text: '恢复音量'
                        });
                    } else {
                        this.play();
                        this.events.trigger('switchVideo_end', this.video);
                    }
                    this.autoPlay = false;
                    this.isSwitched = false;
                    this.isReloaded = false;
                }
                this.checkAutoSkip();
            }
        },
        {
            key: 'checkAutoSkip',
            value: function checkAutoSkip() {
                var _this$options$video$t2;
                var lastPosition = (_this$options$video$t2 = this.options.video[this.currentVideo].lastPosition) !== null && _this$options$video$t2 !== void 0 ? _this$options$video$t2 : 0;
                if (this.video.duration > 60 && lastPosition > 10 && this.video.duration - lastPosition > 10 && !this.networkError) {
                    if (this.autoSkip) {
                        this.skip('已为你自动跳转至', lastPosition, !!this.autoSkip);
                    } else
                        this.skip('是否跳转至上次观看位置', lastPosition, !!this.autoSkip);
                }
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'mute',
            value: function mute() {
                var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.video.muted = flag;
                this.template.volumeIcon.classList[flag ? 'add' : 'remove']('button-volume-off');
                this.controller.components.volumeSlider.setValue(flag ? 0 : this.video.volume * 100);
            }
        },
        {
            key: 'initMSE',
            value: function initMSE(video) {
                var _this7 = this;
                var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mp4';
                this.type = type;
                switch (this.type) {
                case 'hls':
                case 'm3u8':
                    if (window.Hls) {
                        if (window.Hls.isSupported()) {
                            var options = this.options.pluginOptions.hls;
                            var hls = new window.Hls(options);
                            this.plugins.hls = hls;
                            hls.loadSource(video.src);
                            hls.attachMedia(video);
                            this.events.on('destroy', function () {
                                hls.destroy();
                                delete _this7.plugins.hls;
                            });
                        } else {
                            this.notice('Error: Hls is not supported.');
                        }
                    } else {
                        this.notice('Error: Can\'t find Hls.');
                    }
                    break;
                case 'flv':
                    if (window.flvjs) {
                        if (window.flvjs.isSupported()) {
                            var flvPlayer = window.flvjs.createPlayer(Object.assign(this.options.pluginOptions.flv.mediaDataSource || {}, {
                                type: 'flv',
                                url: video.src
                            }), this.options.pluginOptions.flv.config);
                            this.plugins.flvjs = flvPlayer;
                            flvPlayer.attachMediaElement(video);
                            flvPlayer.load();
                            this.events.on('destroy', function () {
                                flvPlayer.unload();
                                flvPlayer.detachMediaElement();
                                flvPlayer.destroy();
                                delete _this7.plugins.flvjs;
                            });
                        } else {
                            this.notice('Error: flvjs is not supported.');
                        }
                    } else {
                        this.notice('Error: Can\'t find flvjs.');
                    }
                    break;
                case 'dash':
                    if (window.dashjs) {
                        var dashjsPlayer = window.dashjs.MediaPlayer().create().initialize(video, video.src, false);
                        var _options = this.options.pluginOptions.dash;
                        this.plugins.dash = dashjsPlayer;
                        this.events.on('destroy', function () {
                            window.dashjs.MediaPlayer().reset();
                            delete _this7.plugins.dash;
                        });
                    } else {
                        this.notice('Error: Can\'t find dashjs.');
                    }
                    break;
                case 'webtorrent':
                    if (window.WebTorrent) {
                        if (window.WebTorrent.WEBRTC_SUPPORT) {
                            this.container.classList.add('mfunsPlayer-loading');
                            var _options2 = this.options.pluginOptions.webtorrent;
                            var client = new window.WebTorrent(_options2);
                            this.plugins.webtorrent = client;
                            var torrentId = video.src;
                            video.src = '';
                            video.preload = 'metadata';
                            video.addEventListener('durationchange', function () {
                                return _this7.container.classList.remove('mfunsPlayer-loading');
                            }, { once: true });
                            client.add(torrentId, function (torrent) {
                                var file = torrent.files.find(function (file) {
                                    return file.name.endsWith('.mp4');
                                });
                                file.renderTo(_this7.video, {
                                    autoPlay: _this7.options.autoPlay,
                                    controls: false
                                });
                            });
                            this.events.on('destroy', function () {
                                client.remove(torrentId);
                                client.destroy();
                                delete _this7.plugins.webtorrent;
                            });
                        } else {
                            this.notice('Error: Webtorrent is not supported.');
                        }
                    } else {
                        this.notice('Error: Can\'t find Webtorrent.');
                    }
                    break;
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.events.on(name, callback);
            }
        },
        {
            key: 'off',
            value: function off(name, callback) {
                this.events.off(name, callback);
            }
        },
        {
            key: 'initVideo',
            value: function initVideo(video, type) {
                var _this8 = this;
                this.initMSE(video, type);
                if (this.options.video.length > 1 && this.currentVideo <= this.options.video.length) {
                    this.template.pagelistItem[this.currentVideo].classList.add('focus');
                }
                this.on('canplay', function () {
                    console.log('canplay');
                    _this8.videoLoaded && _this8.template.loading.classList.remove('show');
                    _this8.canplay = true;
                });
                this.on('loadstart', function () {
                    if (!_this8.switchingResolution) {
                        clearTimeout(_this8.loadTimer);
                        _this8.hideTip();
                        _this8.template.loading.classList.add('show');
                        _this8.template.loadingSpeed.innerHTML = '';
                        _this8.template.headBar.classList.add('disable');
                        _this8.template.footBar && _this8.template.footBar.classList.add('loading');
                        _this8.template.controllerMask.classList.add('disable');
                        _this8.template.bezel.classList.add('hide');
                        _this8.template.danmakuRoot && _this8.template.danmakuRoot.classList.add(_this8.options.uid ? 'loading' : 'nologin');
                        _this8.videoLoaded = false;
                        _this8.loadTimer = setTimeout(function () {
                            if (!_this8.videoLoaded && !_this8.networkError) {
                                _this8.removeMask('error');
                                _this8.template.loading.classList.remove('show');
                                _this8.notice('视频响应超时\uFF0C您可以', true, {
                                    callback: function callback() {
                                        _this8.reload();
                                    },
                                    text: '重新加载'
                                });
                            } else {
                                clearTimeout(_this8.loadTimer);
                            }
                        }, 30000);
                    }
                });
                this.on('error', function (error) {
                    console.error(error);
                    _this8.template.videoLoad.innerHTML = '请求视频数据中... [失败]';
                    _this8.networkError = true;
                    if (error.type === 'error') {
                        setTimeout(function () {
                            _this8.removeMask('error');
                            _this8.template.loading.classList.remove('show');
                            _this8.notice('视频加载失败,请检查网络设置或视频链接是否可用', true, {
                                callback: function callback() {
                                    _this8.reload();
                                },
                                text: '重新加载'
                            });
                        }, 500);
                    }
                });
                this.on('loadedmetadata', function (e) {
                    _this8.template.headBar.classList.remove('disable');
                    _this8.template.controllerMask.classList.remove('disable');
                    _this8.template.bezel.classList.remove('hide');
                    _this8.video.classList.add('mfunsPlayer-video-current');
                    _this8.template.videoLoad.innerHTML = '请求视频数据中... [完成]';
                    _this8.videoLoaded = true;
                    _this8.removeMask();
                    _this8.danLength >= 0 && _this8.loadHighEnergy();
                    !_this8.switchingResolution && _this8.initResolution();
                    _this8.template.currentTime.innerText = '00:00';
                    _this8.template.totalTime.innerText = utils.secondToTime(_this8.video.duration);
                    if (_this8.timeBeforeReload) {
                        _this8.seek(_this8.timeBeforeReload);
                    }
                });
                this.on('progress', function (e) {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this8.bar.set('loaded', percentage, 'width');
                });
                this.on('play', function () {
                    clearTimeout(_this8.playTimer);
                    _this8.playEnd && _this8.danmaku && _this8.danmaku.seek();
                    _this8.danmaku && _this8.danmaku.play();
                    _this8.advancedDanmaku && _this8.advancedDanmaku.play();
                    _this8.videoLoaded && _this8.timer.enable('loading');
                    _this8.playEnd = false;
                    _this8.controller.setAutoHide();
                    _this8.container.classList.remove('mfunsPlayer-paused');
                    _this8.container.classList.add('mfunsPlayer-playing');
                    _this8.template.play_btn.classList.remove('button-paused');
                    if (_this8.danmaku.miniMode) {
                        _this8.template.bezel.classList.add('icon-pause');
                        _this8.template.bezel.classList.remove('icon-play');
                    } else {
                        _this8.template.bezel.classList.remove('icon-play');
                        _this8.template.bezel.classList.remove('icon-pause');
                    }
                    _this8.playTimer = setTimeout(function () {
                        _this8.template.bezel.classList.add('hide');
                    }, 1500);
                    _this8.updateVideoPosition(_this8.video.currentTime);
                });
                this.on('pause', function () {
                    clearTimeout(_this8.playTimer);
                    clearTimeout(_this8.timeUpdateTimer);
                    _this8.danmaku && _this8.danmaku.pause();
                    _this8.advancedDanmaku && _this8.advancedDanmaku.pause();
                    _this8.updateVideoPosition(_this8.video.currentTime);
                    _this8.controller.setAutoHide();
                    _this8.container.classList.add('mfunsPlayer-paused');
                    _this8.container.classList.remove('mfunsPlayer-playing');
                    _this8.template.play_btn.classList.add('button-paused');
                    _this8.template.bezel.classList.remove('hide');
                    if (_this8.danmaku.miniMode) {
                        _this8.template.bezel.classList.add('icon-play');
                        _this8.template.bezel.classList.remove('icon-pause');
                    } else {
                        _this8.template.bezel.classList.remove('icon-play');
                        _this8.template.bezel.classList.remove('icon-pause');
                    }
                    _this8.template.loading.classList.remove('show');
                });
                this.on('timeupdate', function () {
                    if (!_this8.unableTimeupdate) {
                        _this8.bar.set('played', _this8.video.currentTime / _this8.video.duration, 'width');
                        _this8.highEnergy && _this8.highEnergy.update(_this8.video.currentTime / _this8.video.duration);
                        var ct = parseInt(_this8.video.currentTime);
                        _this8.template.currentTime.innerText = utils.secondToTime(ct);
                        _this8.updateVideoPosition(_this8.video.currentTime);
                    }
                });
                this.on('ended', function () {
                    _this8.bar.set('played', 1, 'width');
                    _this8.playEnd = true;
                    _this8.autoSwitch && !_this8.video.loop && _this8.switchVideo(_this8.currentVideo + 1);
                });
                this.on('seeking', function () {
                    console.log('seeking');
                    _this8.timer.enable('loading');
                    _this8.template.loading.classList.add('show');
                    _this8.bar.set('played', _this8.video.currentTime / _this8.video.duration, 'width');
                    _this8.highEnergy && _this8.highEnergy.update(_this8.video.currentTime / _this8.video.duration);
                    var ct = parseInt(_this8.video.currentTime);
                    _this8.template.currentTime.innerText = utils.secondToTime(ct);
                    _this8.updateVideoPosition(_this8.video.currentTime);
                    _this8.danmaku && _this8.danmaku.seek();
                    _this8.advancedDanmaku && _this8.advancedDanmaku.seek();
                });
                var _loop = function _loop(i) {
                    video.addEventListener(_this8.events.videoEvents[i], function (e) {
                        _this8.events.trigger(_this8.events.videoEvents[i], e);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop(i);
                }
                this.events.videoEvents.forEach(function (eventName) {
                    if (_this8.events.events[eventName]) {
                        var eventQueue = _this8.events.events[eventName];
                        var newEventQueque = [];
                        eventQueue.forEach(function (event) {
                            newEventQueque.length === 0 && newEventQueque.push(event);
                            !newEventQueque.map(function (ev) {
                                return ev.toString();
                            }).includes(event.toString()) && newEventQueque.push(event);
                        });
                        _this8.events.events[eventName] = newEventQueque;
                    }
                });
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(index) {
                var _currentVideo$pic;
                var total = this.options.video.length - 1;
                if (index > total || index < 0 || index === this.currentVideo)
                    return;
                this.updateVideoPosition(this.video.currentTime);
                this.currentVideo = index;
                this.isSwitched = true;
                this.danmakuLoaded = false;
                this.videoLoaded = false;
                this.template.initHitokoto(this.options);
                this.template.currentTime.innerText = '00:00';
                this.template.totalTime.innerText = '00:00';
                this.bar.set('loaded', 0, 'width');
                this.bar.set('played', 0, 'width');
                clearTimeout(this.timeUpdateTimer);
                this.handleSwitchVideo(index, total);
                this.events && this.events.trigger('switchVideo_start', index);
                this.showMask();
                var currentVideo = this.options.video[index];
                this.danmaku && this.danmaku.reload(currentVideo.danId, currentVideo.advDanId ? {
                    id: currentVideo.advDanId,
                    address: this.options.advancedDanmaku.api,
                    token: this.options.advancedDanmaku.token
                } : null, currentVideo.danmakuAddition, currentVideo.otherDanParams);
                this.controller.thumbnails && this.controller.thumbnails.reload(currentVideo.thumbnails);
                this.video.poster = (_currentVideo$pic = currentVideo.pic) !== null && _currentVideo$pic !== void 0 ? _currentVideo$pic : '';
                this.video.src = currentVideo.url;
                this.template.headTitle.innerText = ''.concat(currentVideo.title);
            }
        },
        {
            key: 'handleSwitchVideo',
            value: function handleSwitchVideo(index, total) {
                this.template.loadingSpeed.innerHTML = '';
                if (this.template.footBar) {
                    this.template.footBar.classList.add('loading');
                    this.template.danmakuCount.innerHTML = '弹幕装填中...';
                }
                this.template.activityMask.classList.remove('show');
                this.template.prev_btn.classList[index === 0 ? 'add' : 'remove']('disabled');
                this.template.next_btn.classList[index === total ? 'add' : 'remove']('disabled');
                this.template.pagelistItem[index].classList.add('focus');
                this.template.pagelistItem.forEach(function (element, i) {
                    if (i !== index) {
                        element.classList.remove('focus');
                    }
                });
            }
        },
        {
            key: 'initResolution',
            value: function initResolution() {
                var _currentVideoOption$r, _currentVideoOption$r2;
                console.log('当前视频分辨率为'.concat(this.video.videoWidth, ' * ').concat(this.video.videoHeight));
                var currentVideoOption = this.options.video[this.currentVideo];
                var resolution = (_currentVideoOption$r = currentVideoOption === null || currentVideoOption === void 0 ? void 0 : (_currentVideoOption$r2 = currentVideoOption.resolution) === null || _currentVideoOption$r2 === void 0 ? void 0 : _currentVideoOption$r2.find(function (el) {
                    return el.isDefault;
                }).name) !== null && _currentVideoOption$r !== void 0 ? _currentVideoOption$r : utils.getVideoResolution(this.video);
                if (!currentVideoOption.resolution) {
                    currentVideoOption.resolution = [{
                            name: resolution,
                            label: utils.resolutionMap.get(resolution),
                            isDefault: true
                        }];
                    this.resolution = currentVideoOption.resolution[0];
                }
                var newResolutionHTML = tplResolution(currentVideoOption);
                this.template.resolutionInfo.innerHTML = this.resolution.name + ' ' + this.resolution.label;
                this.template.resolutionMask.innerHTML = new DOMParser().parseFromString(newResolutionHTML, 'text/html').body.firstChild.innerHTML;
                this.template.resolutionItem = document.querySelectorAll('.mfunsPlayer-resolution-item');
                this.controller.initResolutionButton();
            }
        },
        {
            key: 'switchResolution',
            value: function switchResolution(resolution) {
                var _this9 = this;
                var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
                };
                var name = resolution.name, url = resolution.url, type = resolution.type, label = resolution.label;
                if (this.resolution.name === resolution.name || this.switchingResolution) {
                    return;
                } else {
                    this.prevResolution = this.resolution;
                    this.resolution = resolution;
                }
                this.switchingResolution = true;
                this.template.resolutionInfo.innerHTML = name + ' ' + label;
                var videoHTML = tplVideo({
                    current: false,
                    pic: null,
                    preload: 'auto',
                    url: url
                });
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                videoEle.style.width = this.video.style.width;
                videoEle.style.height = this.video.style.height;
                videoEle.style.objectFit = this.video.style.objectFit;
                videoEle.style.filter = this.video.style.filter;
                this.template.videoMask.insertBefore(videoEle, this.video);
                this.prevVideo = this.video;
                this.prevEvents = this.events.events;
                this.initVideo(videoEle, type || this.options.video[this.currentVideo].type, true);
                this.notice('切换中', true);
                this.events.trigger('resolution_start', this.resolution.name);
                var loadedmetadata = function loadedmetadata() {
                    if (_this9.prevVideo) {
                        videoEle.currentTime = _this9.prevVideo.currentTime;
                        var canplay = function canplay() {
                            if (_this9.prevVideo) {
                                var _paused = _this9.prevVideo.paused;
                                _this9.prevVideo.style.display = 'none';
                                _this9.prevVideo.pause();
                                _this9.template.videoMask.removeChild(_this9.prevVideo);
                                _this9.prevVideo = null;
                                _this9.video = videoEle;
                                _this9.video.classList.add('mfunsPlayer-video-current');
                                !_paused && _this9.play();
                                _this9.notice('已切换至 '.concat(_this9.resolution.name));
                                _this9.options.video.forEach(function (_ref, v_index) {
                                    var resolution = _ref.resolution, url = _ref.url;
                                    if (!resolution)
                                        return;
                                    resolution.forEach(function (_, index) {
                                        _this9.options.video[v_index].resolution[index].isDefault = false;
                                    });
                                    var r_index = resolution.map(function (r) {
                                        return r.name;
                                    }).indexOf(name);
                                    if (r_index > -1) {
                                        _this9.options.video[v_index].resolution[r_index].isDefault = true;
                                    } else {
                                        var fix_resolution = parseInt(name) - Math.min.apply(Math, _toConsumableArray(resolution.map(function (el) {
                                            return Math.abs(parseInt(el.name) - parseInt(name));
                                        }))) + 'P';
                                        var fix_index = resolution.map(function (r) {
                                            return r.name;
                                        }).indexOf(fix_resolution);
                                        _this9.options.video[v_index].resolution[fix_index].isDefault = true;
                                    }
                                });
                                _this9.switchingResolution = false;
                                videoEle.removeEventListener('canplay', canplay);
                                videoEle.removeEventListener('loadedmetadata', loadedmetadata);
                                _this9.events.trigger('resolution_end');
                            }
                        };
                        _this9.video.currentTime = _this9.prevVideo.currentTime;
                        videoEle.addEventListener('canplay', canplay);
                    }
                };
                videoEle.addEventListener('loadedmetadata', loadedmetadata);
                videoEle.addEventListener('error', function () {
                    if (!_this9.video.error) {
                        return;
                    }
                    if (_this9.prevVideo) {
                        _this9.template.videoWrap.removeChild(_this9.video);
                        _this9.resolution = _this9.prevResolution;
                        _this9.events.events = _this9.prevEvents;
                        _this9.template.resolution.innerHTML = _this9.prevResolution.name;
                        if (!paused) {
                            _this9.play();
                        }
                        _this9.notice('切换失败');
                        _this9.prevVideo = null;
                        _this9.switchingResolution = false;
                    }
                });
            }
        },
        {
            key: 'updateVideoPosition',
            value: function updateVideoPosition(time) {
                if (this.template.mask.classList.contains('mfunsPlayer-mask-show'))
                    return;
                this.options.video[this.currentVideo].lastPosition = time;
                this.events && this.events.trigger('update_video_position', {
                    link: this.options.video[this.currentVideo].url,
                    position: parseInt(time)
                });
            }
        },
        {
            key: 'theme',
            value: function theme(color) {
                this.template.setTheme(color);
                this.highEnergy && this.highEnergy.reload(this.video.currentTime / this.video.duration);
            }
        },
        {
            key: 'volume',
            value: function volume(percentage, nonotice) {
                var _this10 = this;
                percentage = parseFloat(percentage);
                if (!isNaN(percentage)) {
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    this.controller.components.volumeSlider.setValue(percentage * 100);
                    var formatPercentage = ''.concat((percentage * 100).toFixed(0));
                    if (!nonotice) {
                        clearTimeout(this.voiceTimer);
                        this.template.voice.classList.add('show');
                        this.template.voiceValue.innerText = ''.concat(Math.round(percentage * 100), '%');
                        this.voiceTimer = setTimeout(function () {
                            _this10.template.voice.classList.remove('show');
                        }, 700);
                    }
                    this.switchVolumeIcon(formatPercentage);
                    this.video.volume = percentage;
                    this.events && this.events.trigger('setPlayer', {
                        key: 'volume',
                        value: Number(percentage.toFixed(2))
                    });
                }
                return this.video.volume;
            }
        },
        {
            key: 'switchVolumeIcon',
            value: function switchVolumeIcon(percentage) {
                if (percentage > 0) {
                    this.template.volumeIcon.classList.remove('button-volume-off');
                } else {
                    this.template.volumeIcon.classList.add('button-volume-off');
                }
            }
        },
        {
            key: 'speed',
            value: function speed(rate) {
                this.video.playbackRate = rate;
                return rate;
            }
        },
        {
            key: 'update',
            value: function update(url) {
            }
        },
        {
            key: 'reload',
            value: function reload() {
                this.template.activityMask.classList.remove('show');
                clearTimeout(this.timeUpdateTimer);
                this.showMask();
                this.template.initHitokoto(this.options);
                this.timeBeforeReload = this.video.currentTime;
                this.isReloaded = true;
                this.networkError = false;
                this.timer.disable('loading');
                this.template.currentTime.innerText = '00:00';
                this.template.totalTime.innerText = '00:00';
                this.template.barTime.classList.add('hidden');
                this.bar.set('loaded', 0, 'width');
                this.bar.set('played', 0, 'width');
                var currentVideo = this.options.video[this.currentVideo];
                this.video.src = currentVideo.url;
                this.danmaku && this.danmaku.reload(currentVideo.danId, currentVideo.advDanId ? {
                    id: currentVideo.advDanId,
                    address: this.options.advancedDanmaku.api,
                    token: this.options.advancedDanmaku.token
                } : null, currentVideo.danmakuAddition);
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.danmaku && this.danmaku.resize();
                this.advancedDanmaku && this.advancedDanmaku.resize();
                if (this.controller.thumbnails) {
                    this.controller.thumbnails.resize(160, this.video.videoHeight / this.video.videoWidth * 160, this.template.barWrap.offsetWidth);
                }
                window.removeEventListener('resize', this.rescale);
                if (this.controller.videoScale) {
                    this.rescale();
                    this.video.style['object-fit'] = 'fill';
                    window.addEventListener('resize', this.rescale);
                } else {
                    this.video.style['object-fit'] = '';
                    this.video.style.width = '';
                    this.video.style.height = '';
                }
                this.events.trigger('resize');
            }
        },
        {
            key: 'rescale',
            value: function rescale() {
                var hscale = this.template.videoMask.clientWidth * this.controller.videoScale[1];
                var wscale = this.template.videoMask.clientHeight * this.controller.videoScale[0];
                if (wscale > hscale) {
                    this.video.style.width = '100%';
                    this.video.style.height = ''.concat(hscale / wscale * 100, '%');
                } else {
                    this.video.style.height = '100%';
                    this.video.style.width = ''.concat(wscale / hscale * 100, '%');
                }
            }
        },
        {
            key: 'initPlayerTip',
            value: function initPlayerTip() {
                var _this11 = this;
                this.template.playerTip.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
                this.template.noticeClose.addEventListener('click', function () {
                    _this11.hideTip('notice');
                });
                this.template.skipClose.addEventListener('click', function () {
                    _this11.hideTip('skip');
                });
                this.template.skipLink.addEventListener('click', function () {
                    if (_this11.template.skipLink.classList.contains('autoSkip')) {
                        return;
                    } else {
                        _this11.seek(utils.textToSecond(_this11.template.skipLink.innerText));
                        _this11.hideTip('skip');
                    }
                });
            }
        },
        {
            key: 'hideTip',
            value: function hideTip() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
                switch (type) {
                case 'all':
                    this.template.notice.classList.remove('show');
                    this.template.skip.classList.remove('show');
                    break;
                case 'notice':
                    this.template.notice.classList.remove('show');
                    break;
                case 'skip':
                    this.template.skip.classList.remove('show');
                }
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var _this12 = this;
                var alive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var todo = arguments.length > 2 ? arguments[2] : undefined;
                this.template.noticeText.innerHTML = text;
                this.noticeTime && clearTimeout(this.noticeTime);
                this.template.notice.classList.add('show');
                if (todo) {
                    this.template.noticeTodo.classList.add('show');
                    this.template.noticeTodo.innerHTML = todo.text;
                    this.template.noticeTodo.addEventListener('click', function (e) {
                        e.stopPropagation();
                        todo.callback();
                        _this12.hideTip('notice');
                    });
                } else {
                    this.template.noticeTodo.classList.remove('show');
                }
                if (!alive) {
                    this.noticeTime = setTimeout(function () {
                        _this12.template.notice.classList.remove('show');
                        _this12.events.trigger('notice_hide');
                    }, 2000);
                }
                this.events.trigger('notice_show', text);
            }
        },
        {
            key: 'mountDanmakuAuxiliary',
            value: function mountDanmakuAuxiliary(el) {
                this.danmakuAuxiliary = new DanmakuAuxiliary(this, el, this.options);
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                this.controller.destroy();
                this.timer.destroy();
                this.video.src = '';
                this.container.innerHTML = '';
                this.events.trigger('destroy');
            }
        }
    ]);
    return mfunsPlayer;
}();
export {
    mfunsPlayer as default
};